<template>
  <Wrapper>
    <main class="main">
      <h1 class="title">{{ Login.title[lang] }}</h1>
      <form
        action="/"
        class="login-form flex-all-center"
        @submit.prevent="onLogin"
      >
        <dl class="login-form__dl">
          <dt class="login-form__dl--dt"> ID </dt>
          <dd class="login-form__dl--dd">
            {{ Login.id_description[lang] }}
          </dd>
          <dd class="login-form__dl--dd">
            <label>
              <input
                v-model="loginId"
                type="text"
                placeholder="ID"
                class="login-id"
              />
            </label>
          </dd>
        </dl>
        <dl class="login-form__dl">
          <dt class="login-form__dl--dt"> {{ Login.password[lang] }} </dt>
          <dd class="login-form__dl--dd">
            {{ Login.password_description[lang] }}
          </dd>
          <dd class="login-form__dl--dd">
            <label>
              <input
                v-model="loginPassword"
                type="password"
                :placeholder="Login.password[lang]"
                class="login-pw"
              />
            </label>
          </dd>
        </dl>
        <button type="submit" class="login-form__button">
          {{ Login.login[lang] }}
        </button>
      </form>
    </main>
  </Wrapper>
</template>

<script>
import Wrapper from "../../../../components/pc/Wrapper";
import Login from "../../../../assets/constants/company/login.json";
import {
  AuthenticationDetails,
  CognitoUser,
  CognitoUserPool,
} from "amazon-cognito-identity-js";
export default {
  data() {
    return {
      loginId: "",
      loginPassword: "",
    };
  },
  methods: {
    onLogin: function () {
      // 認証に必要な情報を作る
      const authenticationDetails = new AuthenticationDetails({
        Username: this.loginId,
        Password: this.loginPassword,
      });
      // ユーザー情報を作る
      const userPool = new CognitoUserPool({
        UserPoolId: process.env.COGNITO.USER_POOL_ID,
        ClientId: process.env.COGNITO.CLIENT_ID,
      });
      const cognitoUser = new CognitoUser({
        Username: this.loginId,
        Pool: userPool,
      });

      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: () => {
          this.$router.push("/company/summary");
        },
        onFailure: (err) => {
          if (
            err.code === "NotAuthorizedException" ||
            err.code === "ResourceNotFoundException"
          ) {
            return alert(this.Login.error.not_authorized[this.lang]);
          } else if (err.code === "UserNotConfirmedException") {
            return alert(this.Login.error.user_not_confirmed[this.lang]);
          } else if (err.code === "InvalidParameterException") {
            return alert(this.Login.error.invalid_parameter[this.lang]);
          } else if (err.code === "UserNotFoundException") {
            return alert(this.Login.error.user_not_found[this.lang]);
          }
        },
      });
    },
  },
  computed: {
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
    Login: function () {
      return Login;
    },
  },
  components: {
    Wrapper,
  },
  name: "Login",
};
</script>

<style scoped lang="scss">
$pageColor: #000;
.main {
  min-height: calc(100vh - 286px);
  .title {
    margin: 60px 0 0 0;
  }
  .login-form {
    margin: 60px 0 0 0;
    padding: 60px 0;
    flex-direction: column;
    background-color: #eee;
    &__dl {
      margin: 0 0 40px 0;
      padding: 0;
      width: 620px;

      &--dt {
        font-size: 24px;
        font-weight: bold;
        color: $pageColor;
      }

      &--dd {
        margin: 15px 0 0 0;
        font-size: 16px;

        .login-id,
        .login-pw {
          width: 550px;
          height: 48px;
          padding: 0 0 0 10px;
          font-size: 16px;
          border: solid 1px #707070;
          outline-color: #707070;
          background-color: #fff;
        }

        .alert {
          background-color: #ffe1e1;
          border: 1px solid #df3e38;
        }
      }
    }
    &__button {
      margin: 40px 0 0 0;
      width: 343px;
      height: 58px;
      font-size: 20px;
      color: $pageColor;
      border: solid 2px $pageColor;
      background-color: #fff;
      &:hover {
        cursor: pointer;
        color: #fff;
        border: solid 2px $pageColor;
        background-color: $pageColor;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pc/company/login/Login.vue